var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isValidStep && _vm.stepComponent)?_c(_vm.stepComponent,{tag:"component",on:{"step":_vm.setStep}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }